/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OccupationCostForecastCapabilityApiModel } from './occupationCostForecastCapabilityApiModel';
import { OccupationCostForecastExaminationApiModel } from './occupationCostForecastExaminationApiModel';


export interface OccupationCostForecastYearApiModel { 
    year: number;
    cost: number;
    capabilities: Array<OccupationCostForecastCapabilityApiModel>;
    chargedExaminations: Array<OccupationCostForecastExaminationApiModel>;
}

